<div class="row">
  <div class="col">
    <h3>{{ 'i18n.base.user-management.header' | translate }}</h3>
  </div>
</div>
<div class="row align-items-center">
  <div class="col-12">
    <div  class="d-flex gap-2 align-items-center mb-2">
      <app-client-autocomplete (selectedClientChange)="onClientSelected($event)" [showSystem]="true"></app-client-autocomplete>
      <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
      <ejs-checkbox label="{{ 'i18n.shared.show-all' | translate }}" [(checked)]="showInactive" cssClass="checkbox-large ms-auto"></ejs-checkbox>
    </div>
  </div>
</div>
<div class="row">
  <div class="col">
    <ejs-grid #grid
              class="grid-with-toolbar"
              width='100%'
              rowHeight='38'
              [dataSource]="data"
              [allowFiltering]='true'
              [filterSettings]='filterSettings'
              [allowSorting]='true'
              [pageSettings]='pageSettings'
              [allowPaging]='true'
              [editSettings]="editSettings"
              [searchSettings]="searchOptions"
              (actionComplete)="actionComplete($event)"
              (actionBegin)="actionBegin($event)">
      <ng-template #toolbarTemplate let-data>
        <ejs-toolbar>
          <e-items>
            <e-item [text]="'i18n.base.user-management.buttons.add-web' | translate" prefixIcon='e-icons icon-add' (click)="addUser(false)"></e-item>
            <e-item [text]="'i18n.base.user-management.buttons.add-mobile' | translate" prefixIcon="e-icons icon-add" (click)="addUser(true)"></e-item>
          </e-items>
        </ejs-toolbar>
      </ng-template>
      <e-columns>
        @for (column of gridColumns; track column.field) {
          <e-column
            [headerText]='column.headerKey | translate'
            [field]='column.field'
            [type]='column.type ?? "string"'
            [visible]='isColumnVisible(column.field, column.visible)'
            [width]='column.width'
            [clipMode]='column.clipMode'
            [isPrimaryKey]='isPrimaryKeyColumn(column.field)'
            [allowFiltering]='isFilteringAllowed(column.allowFiltering)'
            [filter]='getColumnFilter(column.field, column.allowFiltering)'>
            @if (column.filter?.kind === 'boolean') {
              <ng-template #filterItemTemplate let-data>{{formatBooleanFilter(data, column.field, column.filter)}}</ng-template>
              <ng-template #template let-data>
                @if (data[column.field]) {
                  <div class="e-icons icon-checkmark align-middle"></div>
                }
              </ng-template>
            } @else if (column.filter?.kind === 'enum') {
              <ng-template #filterItemTemplate let-data>{{ formatFilter(data, column.field, column.filter) | translate}}</ng-template>
                <ng-template #template let-data>
                  <span>{{formatColumnValue(column.field, data)}}</span>
                </ng-template>
            }
          </e-column>
        }
        <e-column headerText="" [commands]='gridCommands' width='60px'></e-column>
      </e-columns>
      <ng-template #editSettingsTemplate let-data>
        <app-dynamic-edit-form
          [fields]="editFormFields"
          [layout]="crudDefinition.form.layout"
          [formGroup]="gridEditForm!"
          [isEditMode]="isEditMode"
          [initialReferenceItems]="referenceInitialItems"
          [customFieldTemplates]="{ role: roleFieldTemplate }">
        </app-dynamic-edit-form>

        <ng-template #roleFieldTemplate let-formGroup="formGroup" let-field="field">
          <ng-container [formGroup]="formGroup">
            <app-button-group
              [id]="field.key"
              [fieldsEnum]="Role"
              formControlName="role"
              [hide]="hiddenRoles"
              [translateKey]="'i18n.shared.enums.Role.'">
            </app-button-group>
          </ng-container>
        </ng-template>
      </ng-template>
    </ejs-grid>
  </div>
</div>
